import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=6230c0f6&scoped=true&"
var script = {}
import style0 from "./Loading.vue?vue&type=style&index=0&id=6230c0f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6230c0f6",
  null
  
)

export default component.exports